import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "honours-vs-programme",
  title: "DU Honours vs BA Programme: Structural Differences That Actually Matter Under UGCF 2022",
  description:
    "Single-discipline depth vs multi-disciplinary breadth under UGCF 2022. Master's eligibility, fourth-year research options, credit requirements, and career outcomes compared.",
  pubDate: "2026-06-12",
  updatedDate: "2026-07-28",
  authorSlug: "uday-kumar",
  category: "college-life",
  tags: ["DU", "honours", "ba-programme", "UGCF-2022", "academics", "fyup"],
  readMinutes: 15,
  heroEyebrow: "Academics · Degree Architecture Masterclass",
};

export function Body() {
  return (
    <>
      <p>
        Under Delhi University's{" "}
        <a
          href="https://www.du.ac.in/index.php?page=ugcf-2022"
          target="_blank"
          rel="noopener noreferrer"
        >
          Undergraduate Curriculum Framework (UGCF 2022)
        </a>
        , the structural distinction between Single Discipline (Honours) and Multi-Disciplinary (BA Programme) degrees was updated under the National Education Policy (NEP) 2020.
      </p>

      <h2>1. Comparison Table: Honours vs. BA Programme</h2>
      <div className="overflow-x-auto my-6">
        <table className="w-full text-left text-sm border-collapse border border-rule">
          <thead>
            <tr className="bg-card font-semibold border-b border-rule">
              <th className="p-3 border-r border-rule">Feature</th>
              <th className="p-3 border-r border-rule">BA (Hons) Single Discipline</th>
              <th className="p-3">BA Programme Multi-Disciplinary</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-rule">
            <tr>
              <td className="p-3 border-r border-rule font-medium">Core Discipline Concentration</td>
              <td className="p-3 border-r border-rule">High depth in one major discipline (e.g. 18+ Core Papers).</td>
              <td className="p-3">Balanced breadth across two major/minor discipline subjects.</td>
            </tr>
            <tr>
              <td className="p-3 border-r border-rule font-medium">4th Year Research Entry</td>
              <td className="p-3 border-r border-rule">Direct entry into 4th-Year Honours with Research (160 Credits).</td>
              <td className="p-3">Eligible for 4th-Year Honours with Research subject to credit criteria.</td>
            </tr>
            <tr>
              <td className="p-3 border-r border-rule font-medium">Postgraduate Prerequisites</td>
              <td className="p-3 border-r border-rule">Automatically satisfies prerequisites for specialized master's (DSE/JNU).</td>
              <td className="p-3">Must verify specific subject credit thresholds on CUET PG / DSE portals.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>2. Related Academic Guides</h2>
      <p>
        For details on how grading works across both tracks, read{" "}
        <a href="/blog/du-grading-attendance-explained" className="font-semibold underline text-grade">
          DU Grading &amp; Attendance System Explained
        </a>{" "}
        and explore admissions in{" "}
        <a href="/blog/du-csas-round-2-allotment-2026" className="font-semibold underline text-grade">
          DU CSAS Seat Allotment Guide
        </a>
        .
      </p>
    </>
  );
}


